import { post, get, postFile2ImageBase64 } from './http';

export default {
  install(vm) {
    vm.prototype.$get = get;
    vm.prototype.$post = post;
    vm.prototype.$postFile2ImageBase64 = postFile2ImageBase64;
  },
};
